import { EContactMethod } from './contact-method';
import { ECurrency } from './currency';
import { EGTMKYCLimit, EGTMLoginStatus } from './google-tag-manager';
import { ELanguage } from './language';
import { EFullMetalName } from './metal';
import { EFullProductType } from './product-type';
import { EUserType } from './profile';
import { EShopQuery } from './shop';
import { Price } from './unit';

export enum EMixpanelEventName {
  AB_TEST = '$experiment_started',
  ACCOUNT_CREATION_DONE_PAGE = 'Account creation Done page',
  BUDGET_CALCULATOR = 'Budget calculator',
  CAROUSEL_BANNER = 'Carousel_banner',
  CAROUSEL_PRODUCTS = 'Carousel_Products',
  CART_VIEWED = 'Cart viewed',
  FILTERS_INTERACTION = 'Filters_interaction',
  HEADER_INTERACTION = 'Header Interaction',
  INVESTMENT_CHARTS_STRATEGIES = 'I had invested 5 years ago strategies',
  INVESTMENT_CHARTS_USAGE = 'I had invested 5 years ago usage',
  KYC_FLOW_PROGRESSED = 'KYC Flow Progressed',
  MARKET_PRICE_ALERT = 'Market Price Alert',
  PAGE_VIEWED = 'Page viewed',
  PRODUCT_ADDED_TO_CART = 'Product Added to Cart',
  PRODUCT_ALERT = 'Product Alert',
  PRODUCT_REMOVED_FROM_CART = 'Product Removed from Cart',
  SAVINGS_ASSISTANT_USED = 'Savings Assistant Used',
  CAROUSEL_RECENTLY_VIEWED_PRODUCTS = 'Carousel_Recently_Viewed_Products',
  CAROUSEL_RECENTLY_VIEWED_PRODUCTS_ADD_TO_CART = 'Carousel_Recently_Viewed_Products_AddToCart',
  STOCK_ALERT = 'Stock Alert',
  SHOP_PAGE_VIEWED = 'Shop_Category_Pages_All_Languages',
}

export enum EMixpanelPackageSelected {
  COIN = 'Coin',
  FLEXIBLE = 'Flexible',
  BEST_VALUE = 'Best value',
}

export enum EMixpanelStepName {
  PURCHASING_LIMIT = 'Purchasing limit',
  DONE = 'Done',
}

export enum EMixpanelEnv {
  WEB_APP = 'web_app',
}

export enum EMixpanelAccountCreationDoneCtasName {
  SKIP_FOR_NOW = 'Skip for now',
  VERIFY_MY_ACCOUNT = 'Verify my account',
}

export enum EMixpanelHeaderSectionType {
  MENU = 'Menu',
  SUB_MENU = 'Submenu',
  LINK = 'Link',
}

export type MixpanelEventProps = {
  language: ELanguage;
  currency: ECurrency;
  environment: EMixpanelEnv;
  loginStatus?: EGTMLoginStatus;
  productId?: string;
  productCategory?: EFullMetalName;
  productName?: string;
  productPrice?: Price;
  productType?: EFullProductType;
  productWeight?: string;
  productQuantity?: number;
  productGroup?: string;
  packageSelected?: EMixpanelPackageSelected;
  cartSize?: number;
  cartValue?: Price;
  productsCategories?: EFullMetalName[];
  productsIds?: number[];
  productsNames?: string[];
  productsPrices?: Price[];
  stepName?: EMixpanelStepName;
  stepNumber?: number;
  KYCPurchasingLimit?: EGTMKYCLimit;
  imageId?: number;
  userGaPayUsed?: boolean;
  abTestKey?: string;
  isVariant?: boolean;
  accountCreationDoneCtasName?: EMixpanelAccountCreationDoneCtasName;
  metal?: EFullMetalName;
  initialInvestment?: Price;
  monthlyInvestment?: Price;
  assistantMetal?: EFullMetalName;
  assistantBudget?: Price;
  sectionType?: string;
  sectionName?: string;
  urlPath?: string;
  userType?: EUserType;
  filterType?: EShopQuery;
  filterName?: string;
  interactionType?: EMixpanelInteractionType;
  budgetValue?: Price;
  quantityValue?: number;
  alertValue?: number;
  action?: string;
  condition?: string;
  notificationType?: EContactMethod;
  pageUrl?: string;
  productAvailability?: EMixpanelProductAvailability;
  userId?: string;
};

export type MixpanelHeaderEventProps = {
  sectionType?: string;
  sectionName?: string;
  urlPath?: string;
};

export enum EMixpanelInteractionType {
  BUDGET_ENTER = 'budget_entered',
  QUANTITY_ENTER = 'quantity_entered',
  SUGGESTION_CLICK = 'suggestion_clicked',
}

export enum EMixpanelProductAvailability {
  IN_STOCK = 'In Stock',
  PREORDER = 'Preorder',
}
